export default __webpack_public_path__ + "static/media/030-spotlight.9aa85123.svg";